<div class='padding-t-5 margin-r-15 padding-l-5'>
  <button
    mat-button
    class='override-link'
    (click)='toggleOverrideForm()'
    *ngIf='permittedToOverride || theIncident.isOverridden'
  >
    {{
    (permittedToOverride
        ? theIncident.isOverridden
          ? 'FORM.editOverride'
          : 'FORM.applyOverride'
        : 'FORM.viewOverride'
    ) | translate
    }}
  </button>
</div>

<form
  class='padding-t-5 margin-r-15 padding-l-10 margin-t-15 margin-b-15'
  [formGroup]='overrideIncidentIndexForm'
  (submit)='overrideIncidentIndex()'
  *ngIf='theIncident.expandOverrideForm'
>
  <div *ngIf='permittedToOverride'>
    <div>
      <strong> {{ 'FORM.overrideOptions' | translate }} </strong>
      <p>{{ 'FORM.applyRemoveManagerOverrides' | translate }}</p>
    </div>
    <hr />
  </div>

  <div fxLayout='column' class='margin-b-10'>
    <mat-checkbox formControlName='overrideVrmDriverIndex' color='primary'
    >{{ 'FORM.clickOverrideVRMDriverIndex' | translate }}
    </mat-checkbox>

    <div *ngIf='cService.userProfile.companyPermissions.permPointsSystem === cService.permLevels.TRUE'>
      <mat-checkbox formControlName='overrideCompanyPoints' color='primary'
      >{{ 'FORM.clickTurnOnCompanyPointsOverride' | translate }}
      </mat-checkbox>
      <mat-form-field appearance='outline' class='padding-l-10'>
        <mat-select formControlName='overriddenCompanyPointsValue'>
          <mat-option
            *ngFor='
							let companyPointsOverrideOption of dfsService.selectedDriver.companyPointsOverrideOptions
						'
            [value]='companyPointsOverrideOption.options'
          >
            {{ companyPointsOverrideOption.options }}
          </mat-option>
        </mat-select>
        <mat-error
          *ngIf='
						overriddenCompanyPointsValueControl.invalid &&
						overriddenCompanyPointsValueControl.errors.required &&
						overriddenCompanyPointsValueControl.touched
					'
        >
          {{ 'FORM.required' | translate }}
        </mat-error>
      </mat-form-field>
    </div>
  </div>

  <mat-form-field appearance='outline' style='width: 85%' class='margin-t-10'>
    <mat-label>{{ 'FORM.reason' | translate }}</mat-label>
    <textarea matInput formControlName='overrideReason' cols='40' rows='5'></textarea>
    <mat-hint> {{ 'FORM.enterReasonOverride' | translate }}</mat-hint>
    <mat-error
      *ngIf='
				overrideReasonControl.invalid && overrideReasonControl.errors.required && overrideReasonControl.touched
			'
    >
      {{ 'FORM.required' | translate }}
    </mat-error>
  </mat-form-field>

  <div fxLayout='column' *ngIf='permittedToOverride || theIncident.isOverridden'>
    <p>
      {{ 'FORM.appliedBy' | translate }}:
      {{ theIncident.isOverridden ? theIncident.indexOverrideBy : cService.userProfile.username }}
    </p>
    <p>
      {{ 'FORM.date' | translate }}:
      {{ (theIncident.isOverridden ? theIncident.indexOverrideDate : currentDate) | date: 'yyyy-MM-dd' }}
    </p>
  </div>

  <div class='margin-t-10' *ngIf='permittedToOverride'>
    <button mat-flat-button class='blue-color' type='submit'>{{ 'FORM.update' | translate }}</button>
  </div>

  <div class='margin-t-10 note' *ngIf='permittedToOverride'>
    <small>{{ 'FORM.note' | translate }}</small>
    <ul>
      <li>
        <small> {{ 'FORM.allow24Hours' | translate }}</small>
      </li>
      <li>
        <small> {{ 'FORM.selectBothToReduceToZero' | translate }}</small>
      </li>
    </ul>
  </div>
</form>
